import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';
import { SITE_PHOTOS } from '../data/sitePhotos';

export const PhotoCtaBanner = () => {
  const goToBooking = () => {
    const element = document.getElementById('booking');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative isolate overflow-hidden py-20 text-white">
      <img
        src={SITE_PHOTOS.banner.src}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 h-full w-full object-cover"
      />
      <div className="absolute inset-0 -z-10 bg-slate-950/75" aria-hidden="true" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4">
          Ready for a Stress-Free Move or a Spotless Clean?
        </h2>
        <p className="text-lg text-white/90 max-w-2xl mx-auto mb-8">
          Get a free quote today. Licensed and insured crews, clear pricing, and same-day service when available.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            className="bg-bright-orange text-white hover:opacity-90 px-8 py-6 text-lg"
            onClick={goToBooking}
          >
            Get Free Quote
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-white bg-transparent text-white hover:bg-white hover:text-slate-900 px-8 py-6 text-lg"
            onClick={() => window.open('tel:8126694165', '_self')}
          >
            <Phone className="h-5 w-5 mr-2" />
            Call (812) 669-4165
          </Button>
        </div>
      </div>
    </section>
  );
};
